import { getMode } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/app';
import { getIsIssuesLoading } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/issues';
import { getWarnings } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/warnings';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import { createStructuredSelector } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect';
import { connect } from '@atlassian/jira-react-redux';
import type { StateProps } from './types';

import View from './view';

const mapStateToProps = createStructuredSelector<State, StateProps>({
	warnings: getWarnings,
	mode: getMode,
	isLoading: getIsIssuesLoading,
});

const Column = connect(mapStateToProps, {})(View);

// @ts-expect-error: Property 'whyDidYouRender' does not exist on connected component
Column.whyDidYouRender = true;
Column.displayName = 'Column';

export default Column;
